import BResultsFirst from './BResultsFirst'

export default BResultsFirst
